import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

export default function Register() {
    const { register } = useAuth();
    const { t } = useLang();
    const nav = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        const r = await register(email, password, name);
        setBusy(false);
        if (r.ok) {
            toast.success(t("auth.welcomeNew"));
            nav("/community");
        } else {
            setErr(r.error);
        }
    };

    return (
        <div data-testid="register-page" className="min-h-[80vh] max-w-md mx-auto px-5 py-20">
            <p className="text-xs tracking-[0.3em] uppercase text-abnormal-acid font-bold mb-4">{t("auth.regEyebrow")}</p>
            <h1 className="font-display text-6xl uppercase leading-none">{t("auth.regTitle")}</h1>
            <p className="text-zinc-400 mt-4">{t("auth.regSub")}</p>

            <form onSubmit={submit} className="mt-10 space-y-4" data-testid="register-form">
                <div>
                    <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">{t("auth.name")}</label>
                    <input data-testid="register-name" type="text" required minLength={1} maxLength={60} value={name} onChange={(e) => setName(e.target.value)}
                        className="mt-1 w-full bg-abnormal-charcoal border border-white/10 focus:border-abnormal-acid outline-none px-4 py-3" />
                </div>
                <div>
                    <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">{t("auth.email")}</label>
                    <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                        className="mt-1 w-full bg-abnormal-charcoal border border-white/10 focus:border-abnormal-acid outline-none px-4 py-3" />
                </div>
                <div>
                    <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">{t("auth.passwordMin")}</label>
                    <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                        className="mt-1 w-full bg-abnormal-charcoal border border-white/10 focus:border-abnormal-acid outline-none px-4 py-3" />
                </div>
                {err && <p data-testid="register-error" className="text-sm text-abnormal-acid">{err}</p>}
                <button data-testid="register-submit" type="submit" disabled={busy}
                    className="w-full bg-abnormal-acid text-black uppercase tracking-wider font-bold py-3 hover:bg-abnormal-paper hover:text-black transition-colors disabled:opacity-60">
                    {busy ? t("auth.loginBusy") : t("auth.regBtn")}
                </button>
            </form>

            <p className="text-sm text-zinc-500 mt-6">
                {t("auth.hasAccount")}{" "}
                <Link to="/login" className="text-abnormal-acid uppercase tracking-wider font-bold">{t("auth.goLogin")}</Link>
            </p>
        </div>
    );
}
